"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var radioButtonCustom_1 = require("./utils/radioButtonCustom");
var constructionState_1 = require("./utils/constructionState");
var rewriteValueNumber_1 = require("./utils/rewriteValueNumber");
var pavementTypeState_1 = require("./utils/pavementTypeState");
var submitValidation_1 = require("./utils/submitValidation");
var updateTotalValue_1 = require("./utils/updateTotalValue");
document.addEventListener('DOMContentLoaded', function () {
    (0, radioButtonCustom_1.radioButtonCustom)();
    (0, constructionState_1.setConstructionState)();
    (0, rewriteValueNumber_1.rewriteValueNumber)();
    // sonctructionDeletState()
    (0, pavementTypeState_1.setPavementTypeState)();
    (0, submitValidation_1.submitValidation)();
    (0, updateTotalValue_1.updateTotalValue)();
});
